<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="supplierInfoes"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="编号">
              <el-input v-model.trim="filter.no" placeholder="请输入供应商编号" clearable/>
            </el-form-item>
            <el-form-item label="外部编号">
              <el-input v-model.trim="filter.outerNO" placeholder="请输入外部编号" clearable/>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.trim="filter.name" placeholder="请输入供应商名称" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <supplier-manage-edit ref="supplierManageEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import SupplierManageEdit from "./SupplierManageEdit.vue";

  export default {
    name: "SupplierManageList",
    components: { ViewTable, SupplierManageEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(366),
          editAuth: this.$auth(367),
          delAuth: this.$auth(368),
        },
        filter: {
          no: "",
          name: "",
          outerNO: "",
        },
        columnsProperty: [
          {
            key: "no",
            align: "center",
            width: 110,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.supplierManageEdit.open(params.row, true);
                    },
                  },
                },
                params.row.no
              );
            },
          },
          {
            key: "name",
            minWidth: 300,
          },
          {
            key: "outerNO",
            width: 110,
            align: "center",
          },
          {
            key: "contact",
            width: 120,
            tooltip: true,
            align: "cnter",
          },
          {
            key: "mobile",
            width: 130,
            align: "center",
          },
          {
            key: "address",
            width: 320,
            tooltip: true,
          },
          {
            key: "bank",
            width: 180,
            tooltip: true,
          },
          {
            key: "vATNAME",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "vATNO",
            width: 200,
            align: "center",
            tooltip: true,
          },
          {
            key: "accounts",
            width: 200,
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.supplierManageEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "supplierInfoes", row.pkid).then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
